:host {
  display: block;
  width: 100%;
  max-width: var(--cms-container-max-width);
  margin: 0 auto;
  @include cms-base-font-100;
  margin-bottom: var(--cms-spacing-075);
}

.text-link-wrapper {
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
  flex-wrap: wrap;
  background-color: var(--cms-semanticColors-transparency-strong-background);
  margin: 0 auto;
  align-items: center;
  padding: var(--cms-spacing-100);
  border: 1px solid var(--cms-theme-border-color);
}

.text-link-label {
  display: flex;
  flex: 0 0 50%;
  max-width: 50%;
  justify-content: flex-start;
  font-family: var(--cms-brandfont2);
  color: var(--cms-theme-text-color);
  font-weight: var(--cms-heading-base-font-weight);
}

.text-link-anchor {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}